import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './../layout';

import { getContactServiceList, getDeviceAccess, getWishList, partnerApi, vendorDashboard , partnerCategory } from './../../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import {
  Collapse, CardBody, Card, CardHeader, Modal, ModalBody, Row, Col, ModalFooter, ModalHeader
} from 'reactstrap';

import Tabs from "../Tabs";

import TabsPane from "../Tabs/TabsPane";

import DataTable from 'react-data-table-component';

import { MobilePopMenu } from './Common';

import About_other from "./other_info/about_otherV3";
import Keyinfo from "./other_info/keyinfo_otherV3";
import Admission_other from "./other_info/admission_otherV3";
import Gallery from "./other_info/GalleryV3";
import Media from "./other_info/Media";
import Videos from "./other_info/VideosV3";


class partnerAccountInfo extends Component {

  constructor(props) {
    super(props);
    this.state = {
      user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
      authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
      first_name: '',
      last_name: '',
      keyinfodisabled:true,
      admissiondisabled:true,
      mediadisabled:true,
      gallerydisabled:true,
      videosdisabled:true
    }

    this.getPageData();
    this.handleChange = this.handleChange.bind(this);
 
  }
   async getPageData() {
    const { user_type, login_id, set_id } = this.state.user_data;

    let req = JSON.stringify({
      user_type: user_type,
      login_id: login_id,
      sid: set_id,
      url: 'getProfileData'
    });
    partnerApi(req).then(res => {
      if (res.status === 1) {
        let data = res.result;
        this.setState({
          first_name: data.first_name,
          last_name: data.last_name,
        });
      }
    });
  }

  componentDidUpdate() {
    window.jQuery('.selectpicker').selectpicker('refresh');
  }
  
  componentDidMount() {
  }

  handleChange = () => {
    console.log("dfgdgfddfdfdfdf");
    this.setState({ keyinfodisabled: false });
  };
 
  render() {

       const { keyinfodisabled, mediadisabled, admissiondisabled, gallerydisabled, videosdisabled} = this.state;
 
       const childTabs = [
        {
          name: "About",
          id: "About",
          defaultChecked: true,
        },
        {
          name: "Key Information",
          id: "keyinfo",
          //disabled: keyinfodisabled
        },
        {
          name: "Admission/Fee",
          id: "Admission",
          //disabled: admissiondisabled
        },
        {
          name: "Gallery",
          id: "gallery",
          //disabled: gallerydisabled
        } 
        ,
        {
          name: "Videos",
          id: "videos",
          //disabled: videosdisabled
        } 
      
      ];

      
        return (
            <React.Fragment>
                <AdminLayout>
                    
              <div class="col-12 grid-margin">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Account Info <span>(What your customer will see)</span></h4>

                    <div class="desktoponly">
                      <Tabs tabsetName="otherinfo" childTabs={childTabs}>
                        <TabsPane id="About">
                          <About_other handleChange={this.handleChange}/>
                        </TabsPane>
                        <TabsPane id="keyinfo"  >
                          <Keyinfo />
                        </TabsPane>
                        <TabsPane id="Admission">
                          <Admission_other />
                        </TabsPane>
 
                        { /* <TabsPane id="gallery" >
                          <Media />
                        </TabsPane> */}

                        <TabsPane id="gallery" >
                          <Gallery />
                        </TabsPane>
                        <TabsPane id="videos" >
                          <Videos />
                        </TabsPane>
                        
                      </Tabs>
                    </div>

                    <div class="mobileonly">
                        <About_other />
                        <Keyinfo />
                        <Admission_other />
                        <Gallery />
                        <Videos />
                    </div>
                </div>
              </div>

              
            </div>  


                </AdminLayout>
            </React.Fragment>
        )
    }

}

export default partnerAccountInfo;


// WEBPACK FOOTER //
// ./src/components/bewise/partners/accountinfoV3.jsx